import type { ToolResult } from "@/types/tools";

export function csvToMarkdownTable(input: string): ToolResult<string> {
  const lines = input
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);

  if (!lines.length) {
    return { ok: false, error: "Paste CSV content first." };
  }

  const rows = lines.map((line) => line.split(",").map((cell) => cell.trim()));
  const width = rows[0].length;

  if (rows.some((row) => row.length !== width)) {
    return { ok: false, error: "Each row must have the same number of columns." };
  }

  const [header, ...body] = rows;
  const separator = header.map(() => "---");
  const outputRows = [header, separator, ...body].map(
    (row) => `| ${row.map(escapeCell).join(" | ")} |`,
  );

  return { ok: true, value: outputRows.join("\n") };
}

function escapeCell(value: string) {
  return value.replace(/\|/g, "\\|");
}
